<div class="switcher-wrapper" [ngClass]="{ 'switcher-toggled': switcherOpen }">
  <div
    class="switcher-btn"
    (click)="toggleSwitcher()"
    matTooltip="{{ 'Theme.Theme_Setting' | translate }}"
    matTooltipPosition="left"
    aria-label="Theme switcher settings"
  >
    <i class="bx bx-cog bx-spin"></i>
  </div>
  <div class="switcher-body">
    <div class="d-flex align-items-center">
      <h5 class="mb-0 text-uppercase">
        {{ "Theme.Theme_Customizer" | translate }}
      </h5>
      <button
        type="button"
        class="btn-close ms-auto close-switcher"
        aria-label="Close"
        (click)="toggleSwitcher()"
      ></button>
    </div>
    <hr />
    <h6 class="mb-0">{{ "Theme.Theme_Styles" | translate }}</h6>
    <hr />
    <div class="d-flex align-items-center justify-content-start gap-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="theme"
          id="lightmode"
          [(ngModel)]="selectedTheme"
          value="light-theme"
          (change)="applyTheme()"
        />
        <label class="form-check-label" for="lightmode">{{
          "Theme.Light" | translate
        }}</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="theme"
          id="darkmode"
          [(ngModel)]="selectedTheme"
          value="dark-theme"
          (change)="applyTheme()"
        />
        <label class="form-check-label" for="darkmode">Dark</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="theme"
          id="semidark"
          [(ngModel)]="selectedTheme"
          value="semi-dark"
          (change)="applyTheme()"
        />
        <label class="form-check-label" for="semidark">{{
          "Theme.Semi_Dark" | translate
        }}</label>
      </div>
    </div>
    <hr />
    <h6 class="mb-0">{{ "Theme.Theme_Colors" | translate }}</h6>
    <hr />
    <div class="header-colors-indigators">
      <div class="row row-cols-auto g-3">
        <div class="col" *ngFor="let color of sidebarColors; let i = index">
          <div
            [ngClass]="['indigator', color]"
            (click)="applySidebarColor(color)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>